var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"placeholder-wrap"},[_c('div',{staticClass:"placeholder-box",style:(_vm.style)},[_c('span',{staticClass:"placeholder-item placeholder-ani"})])])
}
var staticRenderFns = []

export { render, staticRenderFns }